'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _d3Request = require('d3-request');

var _taJsToolbox = require('ta-js-toolbox');

var _facebookShareIcon = require('./facebookShareIcon.component');

var _facebookShareIcon2 = _interopRequireDefault(_facebookShareIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //region import React

//endregion

//region import additional libraries

//endregion

//region import components


//endregion

//region import CSS
// Semantic UI
require('ta-semantic-ui/semantic/dist/components/reset.css');
require('ta-semantic-ui/semantic/dist/components/site.css');
require('ta-semantic-ui/semantic/dist/components/grid.css');
require('ta-semantic-ui/semantic/dist/components/container.css');
require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/label.css');
require('ta-semantic-ui/semantic/dist/components/list.css');
require('ta-semantic-ui/semantic/dist/components/image.css');

// Specific CSS
require('./../style/Masthead.css');
//endregion


var MastheadComponent = function (_React$Component) {
  _inherits(MastheadComponent, _React$Component);

  function MastheadComponent(props) {
    _classCallCheck(this, MastheadComponent);

    // Set up location info
    var _this = _possibleConstructorReturn(this, (MastheadComponent.__proto__ || Object.getPrototypeOf(MastheadComponent)).call(this, props));

    var publicationLocationInfo = {};

    // Media info has been provided; construct it from the media name.
    //HACK This assumes that all properties use a .ch top level domain,
    // which might not be true.
    if ('mediaName' in props) {
      publicationLocationInfo = {
        publicationDomain: props.mediaName + '.ch',
        publicationName: props.mediaName
      };
    } else if (window.location.hostname !== 'localhost') {
      publicationLocationInfo = (0, _taJsToolbox.parseHostname)(window.location.hostname);
    } else {
      publicationLocationInfo = {
        publicationDomain: window.location.host,
        publicationName: 'localhost'
      };
    }

    _this.state = {
      facebookShares: 0,
      host: publicationLocationInfo
    };
    return _this;
  }

  /**
   * Called once the component has been mounted, checks the Facebook graph
   * for shares and displays them in the header.
   */


  _createClass(MastheadComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.shareUrl) {
        // Get Facebook Share Count
        (0, _d3Request.json)('https://graph.facebook.com/?id=' + this.props.shareUrl).get(function (error, result) {
          if (error || !('share' in result)) {
            _this2.setState({
              facebookShares: 0
            });
            return;
          }
          _this2.setState({
            facebookShares: result.share.share_count || 0
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      // Prepare constants for the inverted version
      var invertedClass = this.props.inverted ? 'inverted' : '';
      var invertedImgSrcName = this.props.inverted ? '-inverted' : '';

      return _react2.default.createElement(
        'div',
        { className: 'ta-masthead masthead-component ' + invertedClass },
        _react2.default.createElement(
          'div',
          { className: 'ui container ' },
          _react2.default.createElement(
            'div',
            { className: 'ui two column middle aligned grid' },
            _react2.default.createElement(
              'div',
              { className: 'column ta-logo' },
              _react2.default.createElement(
                'a',
                { href: 'http://' + this.state.host.publicationDomain },
                ' ',
                _react2.default.createElement('img', {
                  src: '//interaktiv.tagesanzeiger.ch/static/logos/' + this.state.host.publicationName + invertedImgSrcName + '.svg',
                  alt: this.state.host.publicationName + ' Logo',
                  className: 'ui middle aligned logo image' }),
                ' '
              )
            ),
            ' ',
            function () {
              // Conditionals have to be constructed using immediately called
              // functions within JSX
              if (_this3.props.shareUrl) {
                return _react2.default.createElement(
                  'div',
                  { className: 'right aligned column' },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'ui horizontal link list share ' + invertedClass },
                    _react2.default.createElement(_facebookShareIcon2.default, { shareUrl: _this3.props.shareUrl,
                      facebookShares: _this3.state.facebookShares }),
                    _react2.default.createElement(
                      'a',
                      { href: encodeURI('https://twitter.com/intent/tweet?url=' + _this3.props.shareUrl + '&via=' + _this3.state.host.publicationName + (_this3.props.twitterShareText ? '&text=' + _this3.props.twitterShareText : '')),
                        className: 'twitter-share item' },
                      _react2.default.createElement('i', {
                        className: 'twitter icon', style: { height: '1.3em' } })
                    )
                  )
                );
              }
            }(),
            ' '
          )
        )
      );
    }
  }]);

  return MastheadComponent;
}(_react2.default.Component);

MastheadComponent.propTypes = {
  mediaName: _react2.default.PropTypes.string,
  shareUrl: _react2.default.PropTypes.string,
  twitterShareText: _react2.default.PropTypes.string,
  inverted: _react2.default.PropTypes.bool
};

MastheadComponent.defaultProps = {
  inverted: false,
  shareUrl: function () {
    return window.location.toString();
  }()
};

exports.default = MastheadComponent;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-masthead/dist/index.js
// module id = 115
// module chunks = 0